/* unplugin-vue-components disabled */import Tree from 'primevue/tree'

import {Rest} from 'utils'

const __default__ = {
  props: {
    api_url: {type: String, required: true},
    format_filter: {type: Function, required: false, default: undefined}
  },
  data() {
    return {
      rest: new Rest(),
      items: undefined,
      total: undefined,
      filter: undefined,
      // raw filter is string cause input tag value always string
      raw_filter: '',
      expand: undefined,
      loading: true,
      limit: 10,
      skip: 0,
    }
  },
  computed: {
    docs() {
      return this.items.map(item => {
        const expanded_keys = {}
        if (this.expand) {
          for (let node_key of this.expand) {
            expanded_keys[node_key] = true
          }
        }
        
        return {
          'id': item.id,
          nodes: this.transformToNodes(item.data),
          expanded_keys
        }
      })
    }
  },
  watch: {
    api_url: {
      handler: async function () {
        await this.load(0)
      },
      immediate: true
    }
  },
  methods: {
    async onRefresh() {
      await this.load(this.skip, this.filter)
    },
    async onFirst() {
      await this.load(0, this.filter)
    },
    async onPrev() {
      await this.load(this.skip - this.limit, this.filter)
    },
    async onNext() {
      await this.load(this.skip + this.limit, this.filter)
    },
    async onLast() {
      await this.load(Math.floor(this.total/this.limit)*this.limit, this.filter)
    },
    async onResetFilter() {
      this.raw_filter = ''
      await this.load(this.skip)
    },
    async onFilter() {
      let filter = this.raw_filter.trim()
      if (!filter) {
        return this.onResetFilter()
      }

      try {
        filter = this.format_filter(filter)
      }
      catch(ex) {
        $utils.toasts.error(ex.toString(), 5000)
        return
      }

      await this.load(this.skip, filter)
    },
    async load(skip, filter) {      
      this.loading = true

      let raw = undefined

      try {
        raw = await this.rest.get(this.api_url, {skip, filter})
      }
      catch(ex) {
        $utils.toasts.error(ex.toString(), 5000)
        this.total = 0
        this.skip = 0
        this.items = []
        this.expand = undefined
        this.filter = undefined
        this.loading = false
        return
      }

      this.skip = skip
      this.total = raw.total
      this.items = raw.items
      this.expand = raw.expand
      this.filter = filter

      if (this.items.length == 0) {
        if (this.total > 0 && this.skip > 0) {
          // somebody deleted docs while were watching
          // but there are still documents, start from 0
          return await this.load(0)
        }
      }

      this.loading = false
    },
    transformToNodes(document) {
      return Object.entries(document).map(([key, value]) => {
        return this.transformToNode(key, value)
      })
    },
    transformToNode(key, value) {
      const node = {
        key: key,
        label: key,
      }

      if (value && typeof value === 'object') {
        // This is an object or an array
        const childEntries = Object.entries(value)
        //node.icon = 'pi pi-fw pi-folder'; // Use 'pi-folder' for all, opened state is handled by the tree
        
        // Only add children and set as expandable if there are sub-values
        if (childEntries.length > 0) {
          node.children = childEntries.map(([childKey, childValue], index) => {
            return this.transformToNode(childKey, childValue)
          })
        } else {
          node.leaf = true
        }
        
        node.label = key 

        if (Array.isArray(value)) {
          node.data  = `Array (${childEntries.length})`  
        } else {
          node.data = 'Object'
        }
        return node
      }
      
      // This is a primitive value (string, number, boolean, null &c)
      node.leaf = true
      node.label = key

      if (typeof value == 'string') {
        if (value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
          node.data = `UUID('${value}')`
          return node
        }

        if (Date.parse(value)) {
          node.data = value
          node.is_date = true
          return node
        }

        node.data = `"${value}"`
        node.is_str = true
        return node
      }

      node.data = JSON.stringify(value)
      return node
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'docs-list',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get Rest() { return Rest }, get Tree() { return Tree } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})